import * as React from 'react'
import createSvgIcon from '../createSvgIcon'

const uniqueClipId = Math.random().toString(36).substring(7)
export default createSvgIcon(
  <>
    <g clipPath={`url(#${uniqueClipId})`}>
      <rect width='36' height='36' rx='2' fill='#947BFF' />
      <mask
        id='mask0'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='-4'
        y='-3'
        width='46'
        height='46'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M-4 20.392C-4 32.8781 6.12168 42.9998 18.6078 42.9998C31.0936 42.9998 41.2153 32.8781 41.2153 20.392C41.2153 7.90618 31.0936 -2.21582 18.6078 -2.21582C6.12168 -2.21582 -4 7.90618 -4 20.392Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask0)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M30.6579 17.1904C30.6547 17.1257 30.6277 16.7715 30.6161 16.6604C30.6093 16.5989 30.3543 15.2137 30.3205 15.0897C30.3092 15.0469 29.7518 13.5264 29.7354 13.4916C29.6765 13.3651 27.9296 10.8403 27.9013 10.811C27.8031 10.7083 27.2914 10.2217 27.1633 10.1123C27.163 10.1119 27.1623 10.1116 27.162 10.1113C27.162 10.1113 23.1464 7.7124 20.6663 7.7124H16.2192C10.6931 7.7124 6.21313 12.1927 6.21313 17.7185C6.21313 19.2779 6.74991 20.7118 7.64667 21.8475C7.64603 21.8471 7.64538 21.8465 7.64442 21.8462C7.64699 21.8494 8.40562 22.7362 9.55225 23.3338C10.8251 23.9971 12.5001 24.3777 12.5227 24.379C12.6421 24.3854 24.0016 24.389 24.0016 24.389C27.6856 24.389 30.6721 21.4025 30.6721 17.7185C30.6721 17.5414 30.6669 17.3653 30.6579 17.1904Z'
          fill='#F0F0FF'
        />
      </g>
      <mask
        id='mask1'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='-4'
        y='-3'
        width='46'
        height='46'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M-4 20.392C-4 32.8781 6.12168 42.9998 18.6078 42.9998C31.0936 42.9998 41.2153 32.8781 41.2153 20.392C41.2153 7.90618 31.0936 -2.21582 18.6078 -2.21582C6.12168 -2.21582 -4 7.90618 -4 20.392Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask1)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M30.2278 17.2129L30.2043 17.2444L30.2735 17.3211L30.2278 17.2129Z'
          fill='#741DE3'
        />
      </g>
      <mask
        id='mask2'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='-4'
        y='-3'
        width='46'
        height='46'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M-4 20.392C-4 32.8781 6.12168 42.9998 18.6078 42.9998C31.0936 42.9998 41.2153 32.8781 41.2153 20.392C41.2153 7.90618 31.0936 -2.21582 18.6078 -2.21582C6.12168 -2.21582 -4 7.90618 -4 20.392Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask2)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M30.3892 17.7348C30.402 17.7197 30.4223 17.7274 30.4342 17.7116L30.2353 17.4048C30.13 17.5429 30.4616 17.6421 30.3892 17.7348Z'
          fill='#741DE3'
        />
      </g>
      <mask
        id='mask3'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='-4'
        y='-3'
        width='46'
        height='46'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M-4 20.392C-4 32.8781 6.12168 42.9998 18.6078 42.9998C31.0936 42.9998 41.2153 32.8781 41.2153 20.392C41.2153 7.90618 31.0936 -2.21582 18.6078 -2.21582C6.12168 -2.21582 -4 7.90618 -4 20.392Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask3)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M30.3651 17.8251C30.3143 17.9427 30.4015 17.9942 30.4305 18.0244C30.3632 17.9797 30.4633 17.8013 30.3651 17.8251Z'
          fill='#741DE3'
        />
      </g>
      <mask
        id='mask4'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='-4'
        y='-3'
        width='46'
        height='46'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M-4 20.392C-4 32.8781 6.12168 42.9998 18.6078 42.9998C31.0936 42.9998 41.2153 32.8781 41.2153 20.392C41.2153 7.90618 31.0936 -2.21582 18.6078 -2.21582C6.12168 -2.21582 -4 7.90618 -4 20.392Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask4)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M23.4198 24.1318C23.4313 24.1314 23.4468 24.1289 23.4584 24.1257C23.4388 24.1234 23.4265 24.1257 23.4198 24.1318Z'
          fill='#741DE3'
        />
      </g>
      <mask
        id='mask5'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='-4'
        y='-3'
        width='46'
        height='46'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M-4 20.392C-4 32.8781 6.12168 42.9998 18.6078 42.9998C31.0936 42.9998 41.2153 32.8781 41.2153 20.392C41.2153 7.90618 31.0936 -2.21582 18.6078 -2.21582C6.12168 -2.21582 -4 7.90618 -4 20.392Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask5)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M20.5626 24.434L20.5317 24.5055C21.0662 24.3783 21.6661 24.5084 22.2306 24.4536L22.1923 24.4788C22.9081 24.4868 23.5936 24.4849 24.2827 24.424C24.9724 24.3722 25.6428 24.1896 26.291 23.9185C26.2729 23.9333 26.2733 23.9555 26.2549 23.9713C26.3106 23.9243 26.3647 23.856 26.4381 23.8357C26.4623 23.8435 26.4304 23.8737 26.4098 23.8889C26.5746 23.9005 26.7656 23.782 26.9404 23.6738C27.1191 23.5704 27.2682 23.4503 27.3697 23.439C27.4353 23.3843 27.4405 23.3234 27.3816 23.3154C27.8472 23.0317 28.2719 22.6543 28.6557 22.2447C29.0302 21.8249 29.3467 21.3538 29.5741 20.8585C29.6156 20.8218 29.6488 20.8292 29.6768 20.8611C29.9675 19.9576 30.296 19.0608 30.3861 18.1061C30.3375 18.0671 30.3282 18.1985 30.2805 18.1029C30.2161 18.3956 30.3394 18.6657 30.2142 18.9249L30.1714 18.8808C30.1099 19.0698 30.2892 18.9455 30.1791 19.1336C30.1192 19.2035 30.1237 19.1004 30.1108 19.1362C30.0348 19.5522 29.8545 19.9479 29.7943 20.3578C29.6523 20.399 29.603 20.7739 29.4221 20.8511C29.4018 20.9651 29.3358 21.053 29.3731 21.1264C28.9497 21.7382 28.448 22.3046 27.8562 22.7786C27.2663 23.2526 26.584 23.6316 25.8476 23.8509C25.6882 23.9446 25.5082 24.0144 25.3185 24.0711C25.125 24.1091 24.9209 24.1297 24.7141 24.1484C24.5058 24.1558 24.2926 24.141 24.0805 24.1445C23.866 24.1426 23.6396 24.1339 23.4191 24.1529C23.4129 24.1455 23.4139 24.1378 23.42 24.132C23.1306 24.1819 22.7087 24.2054 22.3636 24.1799L22.0705 24.2662C19.9946 24.0869 17.8698 24.2096 15.7613 24.1339C15.1627 24.1172 14.5828 24.1007 14.0129 24.0843C13.7279 24.0769 13.4458 24.0689 13.165 24.0611L12.7448 24.0524L12.5587 24.0492L12.3942 24.0077C11.8668 23.8699 11.3406 23.7143 10.8164 23.5463C10.2925 23.3762 9.76636 23.1972 9.25052 22.9573C9.2634 22.9422 9.25374 22.9235 9.30816 22.9464C8.72856 22.6379 8.30803 22.1906 7.86013 21.7782L7.87623 21.7656L7.84178 21.7353L7.82471 21.7202L7.81698 21.7131L7.81537 21.7122L7.81441 21.7115C7.8128 21.7125 7.81666 21.7089 7.81087 21.7134L7.64858 21.8429L7.5098 22.0145L7.51237 22.0158L8.80198 22.7329L7.81634 21.7141C7.29148 21.1712 6.91314 20.4589 6.67969 19.719C6.44592 18.9765 6.33869 18.2124 6.29232 17.474C6.30585 17.2444 6.31905 17.0116 6.3329 16.7756C6.35479 16.5405 6.40213 16.3048 6.43529 16.0659C6.45397 15.9465 6.47232 15.8264 6.491 15.7063L6.58148 15.3501C6.64717 15.1141 6.68838 14.8684 6.77371 14.6356C7.06544 13.6851 7.52944 12.7815 8.06106 11.963L8.09165 11.9901C8.309 11.6668 8.52763 11.3441 8.80391 11.0743C8.93721 10.9346 9.06762 10.7939 9.20576 10.6612L9.64754 10.2931C9.93058 10.0362 10.2642 9.84363 10.5707 9.61759C10.8866 9.40443 11.2224 9.22025 11.5451 9.00708C11.7293 8.93141 11.9112 8.84931 12.0921 8.76237L12.3626 8.62841L12.6437 8.51443C12.8308 8.43489 13.0189 8.35472 13.2072 8.27486C13.3979 8.19951 13.5959 8.14445 13.791 8.07683C14.1797 7.93065 14.5883 7.85981 14.9946 7.78381C15.1972 7.73712 15.4039 7.73712 15.6087 7.72714C15.8138 7.72006 16.0183 7.71781 16.2205 7.7236C17.2235 7.92227 18.5414 7.49563 19.4836 7.70203C19.964 7.78607 20.456 7.81086 20.9184 7.86174C21.3808 7.9065 21.839 8.00374 22.2975 8.10871C23.213 8.32638 24.1355 8.58817 25.0545 8.91532C25.4122 9.10755 25.7719 9.29334 26.1332 9.47463L26.6738 9.74897L26.9427 9.88743L27.0766 9.95794L27.1436 9.99304C27.1513 10.0004 27.1813 10.0062 27.1401 9.99884C27.122 9.99562 27.0773 10.0178 27.0673 10.0497C27.0564 10.0793 27.0628 10.0983 27.0673 10.1109L27.2228 10.0384L27.2302 10.0449L27.2251 10.0404C27.4801 10.2655 27.7313 10.4876 27.9837 10.7211C28.3775 11.2533 28.7008 11.7618 28.9896 12.3208C29.2807 12.6183 29.4894 12.9986 29.6842 13.4007C29.8355 13.8164 29.9904 14.2424 30.1462 14.6697L30.135 14.6395C30.1839 14.7947 30.2683 14.9595 30.2947 15.1244C30.3678 15.2764 30.4302 15.4193 30.3385 15.544L30.3224 15.5127C30.2409 15.703 30.6614 15.854 30.5471 15.9848L30.6083 16.0028C30.6634 16.2086 30.5494 16.0382 30.5571 16.2018C30.5755 16.2607 30.6637 16.2092 30.655 16.3399C30.5426 16.3696 30.5787 16.4935 30.6112 16.6175C30.6392 16.7418 30.6479 16.8677 30.5207 16.8851C30.5117 16.7727 30.4338 17.0683 30.3594 16.8223C30.3385 16.896 30.3784 17.2345 30.4866 17.1987C30.6048 17.2225 30.7159 17.3558 30.7931 17.1362L30.7046 17.0979C30.7841 17.0206 30.7426 17.0403 30.8047 17.01C30.7906 16.7273 30.9239 16.6755 30.9326 16.4665C30.9306 16.4687 30.9284 16.471 30.9235 16.4684C30.796 16.3422 30.8208 16.1442 30.8144 16.0311L30.853 15.979C30.9387 15.8937 30.6012 15.6927 30.7854 15.7468C30.7506 15.6042 30.7146 15.457 30.6775 15.3057C30.6418 15.1547 30.6183 14.9966 30.5504 14.8488C30.4377 14.5471 30.3224 14.237 30.2084 13.9311C30.1166 13.8693 30.0416 13.4603 29.9756 13.6432C29.9946 13.591 30.0001 13.5225 29.9968 13.4461C29.9946 13.4082 29.9972 13.3727 29.9666 13.3074C29.9495 13.2665 29.9321 13.2243 29.9144 13.1824C29.8461 13.0308 29.7615 12.8923 29.7099 12.8208C29.7244 12.8189 29.7415 12.8163 29.7524 12.8421C29.7138 12.4554 29.3838 12.6041 29.3902 12.2129C29.2302 12.2618 29.1039 11.7061 28.8467 11.6642C28.8534 11.6114 28.8724 11.5824 28.904 11.5779C28.7881 11.4082 28.6734 11.2279 28.5639 11.0521C28.5095 10.9635 28.4558 10.8766 28.4036 10.7926C28.3775 10.7504 28.3518 10.7085 28.3266 10.6679L28.288 10.6064C28.2777 10.5884 28.2394 10.5398 28.2165 10.5082C28.0719 10.3624 27.9596 10.2487 27.8562 10.1444C27.7003 10.0703 27.5606 9.94345 27.4241 9.80693L27.4466 9.82786L27.4196 9.80306L26.7608 10.1109C26.7575 10.0774 26.7534 10.0314 26.7753 9.95827C26.7942 9.88807 26.867 9.77569 26.9829 9.72514C27.2225 9.63595 27.3249 9.75154 27.3165 9.73416L27.2673 9.70292L27.1687 9.64174C27.103 9.60181 27.038 9.5635 26.973 9.53033C26.8425 9.46561 26.7144 9.41828 26.5869 9.41924C26.3444 9.24085 25.949 8.94623 25.5381 8.83353L25.5848 8.83031C25.1556 8.63421 24.6114 8.39947 24.2646 8.39078C24.2057 8.16796 24.0045 8.11805 23.8315 7.99279C23.5044 7.9593 22.9071 7.71555 22.4109 7.66886C22.3623 7.56067 22.0103 7.60704 22.0129 7.48081C21.8377 7.46954 21.6581 7.45795 21.4713 7.45538C21.3795 7.45055 21.2868 7.44604 21.1928 7.44121C21.0978 7.44217 21.0015 7.44282 20.9049 7.44411C20.515 7.44121 20.1601 7.46632 19.7773 7.45377C19.0232 7.43992 18.2581 7.37391 17.5487 7.28311L17.5693 7.27441C17.3851 7.34236 17.1733 7.49337 16.9859 7.58128C16.9672 7.57065 16.9694 7.54972 17.0087 7.55037C16.7498 7.57387 16.5074 7.45151 16.2488 7.47437C16.2508 7.45377 16.2508 7.45377 16.2929 7.43412C16.0495 7.49402 15.7745 7.35813 15.4854 7.46761L15.4664 7.43573L15.2831 7.49144C15.2838 7.45022 15.2854 7.3884 15.3875 7.39645C14.2376 7.47309 13.0907 7.80152 12.0393 8.31415C10.9816 8.82226 10.0294 9.52518 9.17903 10.3199L9.21574 10.2339C9.12301 10.3559 9.01707 10.4635 8.93754 10.5955C8.92433 10.5794 8.93142 10.5565 8.93947 10.534C8.72051 10.7227 8.52989 10.9497 8.34764 11.1774C8.18052 11.4182 8.03143 11.6681 7.8553 11.8861C7.84049 11.8722 7.85884 11.7811 7.79316 11.8313C7.64407 12.2303 7.31209 12.3253 7.39742 12.6193C7.3781 12.6302 7.32594 12.6154 7.33173 12.5697C6.81686 13.6136 6.40116 14.7264 6.15032 15.8682C6.16514 16.1181 6.15515 16.367 6.13165 16.6181C6.12167 16.8696 6.11168 17.1256 6.1017 17.3826C6.06016 17.8929 6.10138 18.4268 6.26721 18.9018L6.2247 18.9043C6.52706 19.9328 6.90315 20.9989 7.58837 21.8938L7.69366 21.7888L7.6914 21.7875L7.19134 21.4327L7.58611 21.8925C7.74099 22.0731 7.9007 22.2283 8.07297 22.3784C8.47772 22.7599 8.8097 22.948 9.2869 23.2301L9.27241 23.2825C9.72997 23.429 10.1521 23.6654 10.6045 23.8798C11.0537 24.0937 11.5261 24.2849 12.0252 24.3065L11.9415 24.3577C12.114 24.2933 12.5069 24.5428 12.4921 24.3435C12.54 24.3767 12.6006 24.3857 12.6556 24.4079C13.327 24.159 13.8496 24.5238 14.6652 24.3628L14.6102 24.4076C14.8266 24.3731 15.078 24.3458 15.2355 24.387C15.2101 24.3931 15.2213 24.4063 15.1698 24.4182C15.8357 24.5963 16.5921 24.4008 17.3014 24.4082L17.2184 24.492C17.5645 24.3941 18.1911 24.4855 18.6435 24.4414L18.6152 24.4807L18.8448 24.4253L18.8486 24.5045C19.4356 24.5103 19.9898 24.4427 20.5626 24.434Z'
          fill='#741DE3'
        />
      </g>
      <mask
        id='mask6'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='-4'
        y='-3'
        width='46'
        height='46'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M-4 20.392C-4 32.8781 6.12168 42.9998 18.6078 42.9998C31.0936 42.9998 41.2153 32.8781 41.2153 20.392C41.2153 7.90618 31.0936 -2.21582 18.6078 -2.21582C6.12168 -2.21582 -4 7.90618 -4 20.392Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask6)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M26.4097 23.8885C26.4078 23.8885 26.4056 23.8891 26.403 23.8885C26.3891 23.9007 26.3969 23.8972 26.4097 23.8885Z'
          fill='#741DE3'
        />
      </g>
      <mask
        id='mask7'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='-4'
        y='-3'
        width='46'
        height='46'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M-4 20.392C-4 32.8781 6.12168 42.9998 18.6078 42.9998C31.0936 42.9998 41.2153 32.8781 41.2153 20.392C41.2153 7.90618 31.0936 -2.21582 18.6078 -2.21582C6.12168 -2.21582 -4 7.90618 -4 20.392Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask7)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M30.9348 16.3909C30.9351 16.4192 30.9348 16.4424 30.9325 16.4663C30.9473 16.4588 30.9357 16.4147 30.9348 16.3909Z'
          fill='#741DE3'
        />
      </g>
      <mask
        id='mask8'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='-4'
        y='-3'
        width='46'
        height='46'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M-4 20.392C-4 32.8781 6.12168 42.9998 18.6078 42.9998C31.0936 42.9998 41.2153 32.8781 41.2153 20.392C41.2153 7.90618 31.0936 -2.21582 18.6078 -2.21582C6.12168 -2.21582 -4 7.90618 -4 20.392Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask8)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M13.9958 12.8405L13.9752 12.8173L13.9224 12.8865L13.9958 12.8405Z'
          fill='#741DE3'
        />
      </g>
      <mask
        id='mask9'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='-4'
        y='-3'
        width='46'
        height='46'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M-4 20.392C-4 32.8781 6.12168 42.9998 18.6078 42.9998C31.0936 42.9998 41.2153 32.8781 41.2153 20.392C41.2153 7.90618 31.0936 -2.21582 18.6078 -2.21582C6.12168 -2.21582 -4 7.90618 -4 20.392Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask9)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M13.658 13.0061C13.669 13.018 13.6661 13.0383 13.677 13.0499C13.7369 12.9829 13.7997 12.9163 13.8664 12.849C13.7665 12.7456 13.7199 13.0753 13.658 13.0061Z'
          fill='#741DE3'
        />
      </g>
      <mask
        id='mask10'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='-4'
        y='-3'
        width='46'
        height='46'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M-4 20.392C-4 32.8781 6.12168 42.9998 18.6078 42.9998C31.0936 42.9998 41.2153 32.8781 41.2153 20.392C41.2153 7.90618 31.0936 -2.21582 18.6078 -2.21582C6.12168 -2.21582 -4 7.90618 -4 20.392Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask10)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M13.5978 12.9931C13.5154 12.96 13.4951 13.054 13.4825 13.0868C13.4993 13.0137 13.6252 13.0868 13.5978 12.9931Z'
          fill='#741DE3'
        />
      </g>
      <mask
        id='mask11'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='-4'
        y='-3'
        width='46'
        height='46'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M-4 20.392C-4 32.8781 6.12168 42.9998 18.6078 42.9998C31.0936 42.9998 41.2153 32.8781 41.2153 20.392C41.2153 7.90618 31.0936 -2.21582 18.6078 -2.21582C6.12168 -2.21582 -4 7.90618 -4 20.392Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask11)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.7102 18.0559C10.7067 18.0495 10.7002 18.0421 10.6948 18.0366C10.6974 18.0488 10.7031 18.0543 10.7102 18.0559Z'
          fill='#741DE3'
        />
      </g>
      <mask
        id='mask12'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='-4'
        y='-3'
        width='46'
        height='46'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M-4 20.392C-4 32.8781 6.12168 42.9998 18.6078 42.9998C31.0936 42.9998 41.2153 32.8781 41.2153 20.392C41.2153 7.90618 31.0936 -2.21582 18.6078 -2.21582C6.12168 -2.21582 -4 7.90618 -4 20.392Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask12)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.9668 19.1898L12.0241 19.1434C11.7102 19.0562 11.5514 18.7255 11.3354 18.502L11.3685 18.5046C10.9371 17.8519 10.6077 17.1428 10.6205 16.306C10.6273 16.3195 10.6482 16.3253 10.656 16.3391C10.6328 16.2986 10.5887 16.2493 10.6035 16.2052C10.6209 16.1958 10.6344 16.2216 10.6395 16.2367C10.7123 16.1575 10.7094 16.0326 10.7094 15.9112C10.7171 15.7921 10.7207 15.6758 10.778 15.6365C10.777 15.586 10.7416 15.5512 10.6952 15.5654C10.7835 15.2476 10.921 14.931 11.0958 14.63C11.2758 14.3318 11.4964 14.0558 11.7366 13.7979C11.7736 13.7899 11.7984 13.8118 11.8164 13.8494C12.1623 13.3307 12.8224 13.1053 13.4232 13.0544C13.439 13.001 13.352 13.0116 13.4045 12.9508C13.1878 12.9137 13.0735 13.1488 12.8758 13.106L12.8832 13.0519C12.747 13.0676 12.8961 13.1774 12.7473 13.1652C12.6823 13.1456 12.7386 13.1024 12.7138 13.1072C12.4533 13.2164 12.1652 13.3259 12.0061 13.5658C11.8892 13.5097 11.7627 13.739 11.6155 13.7219C11.5875 13.8031 11.526 13.8443 11.5527 13.9148C11.1731 14.221 10.8788 14.6387 10.6898 15.0953C10.4985 15.5535 10.4109 16.048 10.3987 16.5401C10.4975 16.7709 10.5056 17.0099 10.5255 17.272C10.5355 17.4021 10.5577 17.5341 10.5803 17.6687C10.6186 17.7981 10.6572 17.9311 10.73 18.048C10.7249 18.0544 10.7175 18.0567 10.7104 18.056C10.7728 18.1256 10.834 18.2164 10.8942 18.311C10.9606 18.4022 11.0192 18.502 11.0652 18.5973L11.2404 18.6875C11.536 19.2397 12.0682 19.6612 12.661 19.9046C12.9599 20.0257 13.2761 20.0988 13.5958 20.14C13.9242 20.1719 14.2266 20.1712 14.526 20.1896C15.8981 20.2408 17.1001 20.3879 18.4364 20.1191C18.4345 20.1384 18.4454 20.1493 18.411 20.158C18.7964 20.1165 19.148 20.1899 19.5109 20.1474L19.5099 20.1674C20.4109 19.9993 21.3852 20.1899 22.254 20.0083C22.7747 20.017 23.3652 20.044 23.9216 19.8486C24.471 19.6573 24.9807 19.3241 25.3384 18.8877L25.3661 18.917C25.6433 18.5567 25.9022 18.1964 26.0919 17.7846C26.2803 17.376 26.3904 16.9126 26.3369 16.4499C26.3633 15.9695 26.1788 15.4839 25.9135 15.0821C25.6462 14.6757 25.3168 14.3431 24.9945 14.0069C24.8313 13.7471 24.498 13.6102 24.1786 13.5329C23.8501 13.4621 23.5436 13.4418 23.2915 13.3085C23.0245 13.1997 22.7389 13.1572 22.4691 13.1362C22.1957 13.1143 21.923 13.1163 21.6506 13.1333C21.1054 13.1678 20.5606 13.2644 20.0074 13.3578C18.9867 13.2467 17.9676 13.531 16.979 13.3053C16.5108 13.4498 15.9934 13.1259 15.4724 13.1678L15.4911 13.218C15.304 13.0657 15.0741 13.4305 14.9575 13.2048L14.9772 13.1942C14.878 13.0789 14.7469 13.4647 14.6867 13.3281L14.6706 13.3848C14.5508 13.4009 14.6568 13.3204 14.564 13.2979C14.5293 13.3053 14.5508 13.4009 14.4781 13.369C14.4623 13.1365 14.1844 13.4193 14.176 13.1584C14.2417 13.1584 14.0733 13.057 14.2208 13.0026C14.1786 12.9759 13.9777 12.9887 13.9957 13.0998C13.9787 13.217 13.9001 13.3194 14.0221 13.4102L14.0466 13.3246C14.0878 13.4102 14.0782 13.3674 14.093 13.4315C14.2524 13.4431 14.2739 13.5671 14.3882 13.6189C14.3869 13.6163 14.386 13.6141 14.3876 13.6099C14.4658 13.5072 14.574 13.568 14.6362 13.5828L14.661 13.6302C14.6983 13.73 14.8426 13.4357 14.794 13.6063C15.1185 13.5638 15.4901 13.5661 15.8527 13.5638C15.9036 13.4991 16.1306 13.5703 16.0514 13.4447C16.1418 13.5877 16.4117 13.6237 16.5118 13.6179C16.5083 13.6311 16.5038 13.6466 16.4883 13.6414C16.6828 13.8266 16.7185 13.4701 16.9008 13.6965C16.9291 13.5365 17.2315 13.7477 17.3345 13.5596C17.3571 13.5951 17.3645 13.6273 17.3564 13.6556C17.6842 13.6591 18.0465 13.7168 18.324 13.7239C18.561 13.5838 18.8978 13.7879 19.1016 13.5941C19.2707 13.635 19.5437 13.7158 19.7798 13.6379L19.7569 13.6617C20.0229 13.6501 20.3552 13.6405 20.5377 13.5188C20.6163 13.7042 20.7313 13.6672 20.8462 13.7261C21.024 13.6405 21.3823 13.6656 21.6535 13.5877C21.695 13.673 21.8769 13.5513 21.8911 13.6756C22.0808 13.6154 22.282 13.5757 22.4894 13.5526C22.6964 13.5297 22.9163 13.5207 23.1079 13.5413C23.505 13.5815 23.8843 13.7593 24.1596 13.9966L24.1467 13.9998C24.2594 13.9741 24.4275 13.8955 24.5611 13.8768C24.564 13.8916 24.5521 13.9084 24.5344 13.8968C24.6722 13.947 24.7034 14.1293 24.8258 14.1917C24.8119 14.2069 24.8119 14.2065 24.782 14.2091C24.9201 14.2461 24.9143 14.4522 25.086 14.488L25.0679 14.5173L25.1655 14.5562C25.1333 14.582 25.085 14.621 25.0615 14.5752C25.4344 14.9993 25.7419 15.5042 25.8865 16.0835C26.0355 16.6582 26.0049 17.3064 25.7445 17.8619L25.728 17.8062L25.6887 18.0486C25.6707 18.038 25.6665 18.0232 25.6633 18.009C25.4653 18.2367 25.3909 18.5632 25.1642 18.7657C25.1507 18.7509 25.1513 18.6913 25.1075 18.7058C25.0332 18.9415 24.7685 18.8333 24.8303 19.0768C24.8152 19.0745 24.7778 19.0368 24.7836 19.0091C24.3653 19.4422 23.7391 19.6869 23.1334 19.6911C22.8928 19.8151 22.5889 19.8122 22.3033 19.8135C22.0131 19.8132 21.7204 19.8071 21.4384 19.8908L21.441 19.8489C20.711 19.9961 19.9363 19.8386 19.1796 19.8679C18.8653 19.8515 18.6531 19.9008 18.3372 19.904L18.3292 19.8515C17.7975 20.0505 17.2122 19.6721 16.6574 19.8917L16.6957 19.8203C16.6097 19.931 16.3601 19.7816 16.393 19.9703L16.2951 19.913C15.9184 20.1625 15.6096 19.798 15.1475 19.96L15.1781 19.9152C15.0554 19.9497 14.9121 19.9774 14.8213 19.9365C14.8355 19.9297 14.8287 19.9165 14.858 19.9049C14.4739 19.722 14.044 19.9371 13.6431 19.8975L13.6963 19.818C13.5974 19.8579 13.4606 19.8367 13.3202 19.8083C13.1824 19.7642 13.0371 19.7266 12.9128 19.6979L12.9402 19.666L12.8011 19.6744L12.8269 19.5994C12.5335 19.4731 12.2247 19.3891 11.9668 19.1898Z'
          fill='#741DE3'
        />
      </g>
      <mask
        id='mask13'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='-4'
        y='-3'
        width='46'
        height='46'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M-4 20.392C-4 32.8781 6.12168 42.9998 18.6078 42.9998C31.0936 42.9998 41.2153 32.8781 41.2153 20.392C41.2153 7.90618 31.0936 -2.21582 18.6078 -2.21582C6.12168 -2.21582 -4 7.90618 -4 20.392Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask13)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.6395 16.237C10.6395 16.237 10.6382 16.2392 10.6366 16.2402C10.6418 16.2508 10.6418 16.2457 10.6395 16.237Z'
          fill='#741DE3'
        />
      </g>
      <mask
        id='mask14'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='-4'
        y='-3'
        width='46'
        height='46'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M-4 20.392C-4 32.8781 6.12168 42.9998 18.6078 42.9998C31.0936 42.9998 41.2153 32.8781 41.2153 20.392C41.2153 7.90618 31.0936 -2.21582 18.6078 -2.21582C6.12168 -2.21582 -4 7.90618 -4 20.392Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask14)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M14.4292 13.6349C14.4138 13.63 14.4012 13.6252 14.3884 13.6188C14.3913 13.6349 14.416 13.631 14.4292 13.6349Z'
          fill='#741DE3'
        />
      </g>
      <mask
        id='mask15'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='-4'
        y='-3'
        width='46'
        height='46'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M-4 20.392C-4 32.8781 6.12168 42.9998 18.6078 42.9998C31.0936 42.9998 41.2153 32.8781 41.2153 20.392C41.2153 7.90618 31.0936 -2.21582 18.6078 -2.21582C6.12168 -2.21582 -4 7.90618 -4 20.392Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask15)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M13.9956 15.4946C14.6097 15.4946 15.1075 15.9924 15.1075 16.6065C15.1075 17.2205 14.6097 17.7183 13.9956 17.7183C13.3816 17.7183 12.8838 17.2205 12.8838 16.6065C12.8838 15.9924 13.3816 15.4946 13.9956 15.4946Z'
          fill='#6200E0'
        />
      </g>
      <mask
        id='mask16'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='-4'
        y='-3'
        width='46'
        height='46'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M-4 20.392C-4 32.8781 6.12168 42.9998 18.6078 42.9998C31.0936 42.9998 41.2153 32.8781 41.2153 20.392C41.2153 7.90618 31.0936 -2.21582 18.6078 -2.21582C6.12168 -2.21582 -4 7.90618 -4 20.392Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask16)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M22.8899 15.4946C23.504 15.4946 24.0018 15.9924 24.0018 16.6065C24.0018 17.2205 23.504 17.7183 22.8899 17.7183C22.2759 17.7183 21.7781 17.2205 21.7781 16.6065C21.7781 15.9924 22.2759 15.4946 22.8899 15.4946Z'
          fill='#6200E0'
        />
      </g>
      <mask
        id='mask17'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='-4'
        y='-3'
        width='46'
        height='46'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M-4 20.392C-4 32.8781 6.12168 42.9998 18.6078 42.9998C31.0936 42.9998 41.2153 32.8781 41.2153 20.392C41.2153 7.90618 31.0936 -2.21582 18.6078 -2.21582C6.12168 -2.21582 -4 7.90618 -4 20.392Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask17)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12.3256 26.9434H24.5602C27.5619 26.9434 29.9952 29.377 29.9952 32.3787C29.9952 32.5909 29.983 32.8028 29.9582 33.014L28.2368 47.643C28.0758 49.0118 26.916 50.0432 25.5378 50.0432H11.3477C9.96954 50.0432 8.8097 49.0118 8.6487 47.643L6.92763 33.014C6.57697 30.0326 8.70956 27.3314 11.6906 26.9804C11.9015 26.9559 12.1134 26.9434 12.3256 26.9434Z'
          fill='#F0F0FF'
        />
      </g>
      <mask
        id='mask18'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='-4'
        y='-3'
        width='46'
        height='46'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M-4 20.392C-4 32.8781 6.12168 42.9998 18.6078 42.9998C31.0936 42.9998 41.2153 32.8781 41.2153 20.392C41.2153 7.90618 31.0936 -2.21582 18.6078 -2.21582C6.12168 -2.21582 -4 7.90618 -4 20.392Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask18)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12.3258 26.9435V26.5126H12.3254L12.3251 26.5123L12.3245 26.512L12.3232 26.5113L12.3206 26.51L12.3154 26.5071L12.3048 26.5017L12.2839 26.4907L12.1767 26.5635L12.251 26.5381L12.2884 26.5252L12.3071 26.5191L12.3164 26.5158L12.3209 26.5142L12.3235 26.5133H12.3248L12.3254 26.5126H12.3258V26.9435Z'
          fill='#741DE3'
        />
      </g>
      <mask
        id='mask19'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='-4'
        y='-3'
        width='46'
        height='46'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M-4 20.392C-4 32.8781 6.12168 42.9998 18.6078 42.9998C31.0936 42.9998 41.2153 32.8781 41.2153 20.392C41.2153 7.90618 31.0936 -2.21582 18.6078 -2.21582C6.12168 -2.21582 -4 7.90618 -4 20.392Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask19)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.6316 26.705C11.6532 26.7137 11.6458 26.7349 11.6677 26.7446L12.0637 26.5295C11.8667 26.4339 11.7552 26.7642 11.6316 26.705Z'
          fill='#741DE3'
        />
      </g>
      <mask
        id='mask20'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='-4'
        y='-3'
        width='46'
        height='46'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M-4 20.392C-4 32.8781 6.12168 42.9998 18.6078 42.9998C31.0936 42.9998 41.2153 32.8781 41.2153 20.392C41.2153 7.90618 31.0936 -2.21582 18.6078 -2.21582C6.12168 -2.21582 -4 7.90618 -4 20.392Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask20)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.5103 26.7057C11.3461 26.6879 11.2959 26.7878 11.2663 26.8235C11.3084 26.7459 11.5583 26.7955 11.5103 26.7057Z'
          fill='#741DE3'
        />
      </g>
      <mask
        id='mask21'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='-4'
        y='-3'
        width='46'
        height='46'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M-4 20.392C-4 32.8781 6.12168 42.9998 18.6078 42.9998C31.0936 42.9998 41.2153 32.8781 41.2153 20.392C41.2153 7.90618 31.0936 -2.21582 18.6078 -2.21582C6.12168 -2.21582 -4 7.90618 -4 20.392Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask21)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7.94865 41.2811L8.024 41.3088C7.8221 40.6825 7.86557 39.9438 7.73066 39.2718L7.76092 39.3153C7.58608 37.5907 7.2805 36.0171 7.0258 34.316C7.03643 34.3417 7.05832 34.3482 7.06992 34.3749C7.03546 34.2953 6.97943 34.2094 6.9746 34.1163C6.98748 34.0902 7.01035 34.1379 7.02129 34.1669C7.09922 33.7921 6.81522 33.1178 6.89282 32.8792C6.87382 32.7784 6.82133 32.7356 6.78785 32.7961C6.71862 32.1116 6.78076 31.3871 6.97879 30.6925C7.17553 29.9973 7.50526 29.3347 7.92707 28.7509C7.98471 28.709 8.01723 28.7206 8.03623 28.7609C8.34986 28.2334 8.82126 27.7817 9.37059 27.459C9.91799 27.1309 10.5327 26.9206 11.1493 26.8025C11.1873 26.7448 11.0105 26.7722 11.1232 26.7001C10.9149 26.7113 10.7404 26.7999 10.5723 26.8723C10.4055 26.9522 10.2535 27.0459 10.0619 27.0678L10.0877 27.006C9.82171 27.0781 10.0845 27.1344 9.80658 27.1995C9.68937 27.213 9.804 27.1315 9.75634 27.1512C9.2434 27.4136 8.715 27.7427 8.4046 28.2015C8.32249 28.2109 8.20174 28.3101 8.09323 28.4334C7.98471 28.557 7.87137 28.6881 7.76157 28.7377C7.70264 28.8819 7.60991 28.9998 7.63341 29.0851C7.0229 29.8801 6.68964 30.8831 6.60817 31.8923C6.58467 32.3927 6.62105 32.9256 6.69511 33.3925C6.75919 33.8713 6.82069 34.3517 6.87543 34.8334C7.1839 35.7102 7.06895 36.8172 7.26279 37.8782C7.25667 37.8863 7.24862 37.8863 7.24186 37.8798C7.33299 38.2221 7.41639 38.727 7.44021 39.1462L7.5674 39.4889C7.68558 42.0123 8.11029 44.5555 8.33633 47.1067C8.35404 47.2873 8.37143 47.467 8.38914 47.6454C8.40878 47.835 8.44485 48.0311 8.49604 48.2179C8.60424 48.5914 8.78584 48.9405 9.0238 49.2412C9.4981 49.8449 10.2062 50.2503 10.9613 50.3486C11.357 50.3952 11.6758 50.3717 12.0177 50.3743C12.3565 50.3708 12.6962 50.3637 13.0375 50.3521C13.7201 50.3289 14.4105 50.2877 15.1189 50.2204C15.115 50.24 15.1379 50.251 15.0648 50.2594C15.8824 50.2185 16.6271 50.2916 17.397 50.2494L17.3945 50.2693C19.3049 50.1009 21.3711 50.2916 23.2126 50.1103C23.7732 50.1122 24.3519 50.1148 24.9418 50.1167C25.2377 50.1135 25.5317 50.127 25.8414 50.0974C26.1476 50.0655 26.4494 49.9773 26.7282 49.8417C27.2875 49.5729 27.7509 49.1072 28.0156 48.5492C28.1476 48.271 28.2352 47.9719 28.2661 47.6689C28.2954 47.3694 28.3247 47.0713 28.354 46.7763L28.3936 46.7866C28.5304 44.8907 28.958 43.0936 29.1152 41.2045C29.4346 39.2799 29.3528 37.1975 29.7048 35.2607C29.8744 34.6685 29.9002 33.9634 29.9256 33.2675C29.9356 33.094 29.9363 32.9201 29.9318 32.7504C29.9247 32.5804 29.944 32.4142 29.9227 32.252C29.9083 32.0897 29.9089 31.9306 29.8989 31.777C29.8841 31.6247 29.8777 31.4756 29.8815 31.3301C29.803 30.1499 29.2066 29.0056 28.2938 28.2489C27.3957 27.4674 26.2153 27.0742 25.0619 27.0546C24.5351 26.9879 23.987 27.0031 23.4493 27.0063C22.91 27.0198 22.3716 27.0333 21.8351 27.0465C20.7626 27.0755 19.6987 27.09 18.6509 26.9773C17.6578 27.1219 16.5611 26.798 15.4563 26.8395L15.4956 26.89C15.0993 26.7377 14.6121 27.1032 14.3645 26.8768L14.4063 26.8665C14.1961 26.7516 13.9185 27.137 13.791 27.0005L13.7568 27.0572C13.5028 27.0736 13.7269 26.9928 13.5305 26.9702C13.4567 26.9773 13.5028 27.0736 13.3486 27.0407C13.3151 26.8089 12.7258 27.0913 12.7084 26.8305C12.8472 26.8305 12.4904 26.7297 12.8028 26.6749C12.7136 26.6482 12.2876 26.6611 12.3259 26.7715C12.2895 26.8894 12.123 26.9915 12.3819 27.0823L12.4341 26.9969C12.5213 27.0823 12.5004 27.0394 12.5316 27.1038C12.8701 27.1151 12.9151 27.2397 13.1579 27.2913C13.1554 27.2887 13.1531 27.2861 13.1566 27.2816C13.3225 27.1792 13.5517 27.2404 13.6831 27.2545L13.7359 27.3025C13.8154 27.4017 14.1207 27.1074 14.018 27.2787C14.7058 27.2362 15.4943 27.2384 16.263 27.2362C16.3705 27.1711 16.8512 27.242 16.6835 27.1171C16.876 27.2597 17.4479 27.2954 17.6604 27.2903C17.6524 27.3038 17.643 27.3189 17.6099 27.3135C18.022 27.4986 18.0983 27.1422 18.4844 27.3685C18.545 27.2088 19.1857 27.4194 19.4044 27.2314C19.452 27.2674 19.4678 27.2993 19.4504 27.3276C20.1456 27.3315 20.9136 27.3888 21.5015 27.3962C22.0042 27.2558 22.7187 27.4597 23.1505 27.2661C23.5079 27.3077 24.0898 27.3866 24.586 27.3112L24.5393 27.3341C25.0706 27.3196 25.7078 27.4316 26.0981 27.4226C26.1885 27.6577 26.4155 27.6851 26.5949 27.8364C26.9542 27.8873 27.549 28.2785 27.993 28.5899C27.9949 28.6494 28.0835 28.7164 28.163 28.784C28.2358 28.8584 28.3012 28.9312 28.2645 28.9834C28.8585 29.4477 29.3602 30.1986 29.5573 31.049C29.6755 31.4682 29.6906 31.9122 29.678 32.3389C29.659 32.5521 29.6226 32.762 29.5946 32.9665C29.5476 33.1845 29.5013 33.3996 29.4555 33.6105L29.4497 33.5847C29.4916 33.8143 29.6111 34.087 29.6719 34.323C29.6587 34.3436 29.6384 34.3385 29.6449 34.2915C29.631 34.6061 29.4755 34.8833 29.4613 35.1973C29.4414 35.1928 29.4414 35.1928 29.4278 35.1399C29.4484 35.4384 29.2578 35.7324 29.3129 36.0882L29.2781 36.104L29.2981 36.3284C29.2578 36.3185 29.1973 36.3027 29.2247 36.1871C28.8698 38.8593 28.7565 41.6475 28.4023 44.3922L28.3755 44.2869L28.382 44.8282C28.362 44.8224 28.3549 44.796 28.3485 44.7696C28.1994 45.4403 28.2319 46.1581 28.1366 46.8178C28.1173 46.8124 28.0896 46.7077 28.0561 46.7976C28.1073 47.2967 27.8249 47.5784 28.0133 47.8228C27.9995 47.8421 27.946 47.845 27.9347 47.7964C27.8597 48.4114 27.5042 49.0055 26.9765 49.3739C26.7147 49.56 26.4149 49.692 26.1022 49.7593C25.7915 49.8321 25.4724 49.814 25.1163 49.8053C23.9651 50.0159 22.6788 49.825 21.4832 49.9924L21.489 49.9506C19.9411 50.0977 18.2989 49.9403 16.6944 49.9696C16.0282 49.9531 15.5781 50.0027 14.9086 50.0053L14.8916 49.9531C13.7649 50.1521 12.5233 49.7738 11.3473 49.9934L11.4285 49.9219C11.2408 50.0436 10.7529 49.8285 10.7854 50.0121L10.5974 49.9077C10.1791 49.9129 9.83652 49.6933 9.56894 49.4138C9.29363 49.1288 9.09013 48.7869 8.8203 48.3721L8.88824 48.4127C8.75235 48.1928 8.64449 47.8959 8.66381 47.6979C8.67508 47.7268 8.6857 47.7111 8.70727 47.7694C8.7765 46.9444 8.48445 46.0628 8.38785 45.2088L8.4822 45.2961C8.33633 44.8946 8.33794 44.1266 8.22975 43.5892L8.27226 43.6175L8.18499 43.3496L8.26292 43.3332C8.18499 42.6261 8.03913 41.9695 7.94865 41.2811Z'
          fill='#741DE3'
        />
      </g>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.2449 27.3071C13.2121 27.3026 13.185 27.2977 13.1577 27.2913C13.1644 27.3071 13.2172 27.3039 13.2449 27.3071Z'
        fill='#741DE3'
      />
    </g>
    <defs>
      <clipPath id={uniqueClipId}>
        <rect width='36' height='36' rx='2' fill='white' />
      </clipPath>
    </defs>
  </>,
  'FleetConcierge',
  '0 0 36 36'
)
